// FILE: frontend/src/components/NavBar.jsx
// SQA-branded navigation bar (Patricia's design)

import React from 'react'
import sqaLogo from '../assets/sqa_fan.png'

export default function NavBar({ lessonTitle, levelCode, mode, onEnd, onLogout }) {
  return (
    <nav className="sqa-nav">
      <div className="sqa-nav-left">
        <div className="sqa-nav-logo">
          <img src={sqaLogo} alt="SQA" style={{ width: '100%', height: '100%', objectFit: 'contain', borderRadius: 8 }} />
        </div>
        <div className="sqa-nav-title">
          SQA <span>Practice</span>
        </div>
        <div className="sqa-nav-divider" />
        <div className="sqa-nav-sub">
          {mode === 'test' ? 'Placement Test' : lessonTitle || 'Lesson'}
        </div>
        {levelCode && <span className="level-badge">{levelCode}</span>}
        <span className="sqa-nav-badge">Beta</span>
      </div>

      <div className="sqa-nav-right">
        {onEnd && (
          <button className="sqa-end-btn" onClick={onEnd}>
            End Session
          </button>
        )}
        {onLogout && (
          <button className="sqa-nav-btn" onClick={onLogout}>
            Logout
          </button>
        )}
      </div>
    </nav>
  )
}
